import {useLocation} from "react-router-dom";
import {useTranslation, withTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import _ from "lodash";
import {Timeline} from "antd";
import comunidades from "../../../../_constants/comunidades";

function TekFPM(props) {
    const {t, i18n} = useTranslation();
    const [timelineData, setTimelineData] = useState([]);

    const {query, search} = useLocation();
    const year = +new URLSearchParams(search).get('year');

    const getPoints = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });
        if (mResult && mResult[0]){

            return +mResult[0].points;

        }else {
            return 0;
        }
    }

    const getResponseB = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });
        if (mResult && mResult[0] && mResult[0].response) {
            if (mResult[0].response.question !== "Ninguna. No quiero hacer Bachillerato" &&
                mResult[0].response.question !== "¡Aún estoy indeciso! Ya lo decidiré más adelante") {
                return true;
            }
        }
        return false;

    }


    const getResponse = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]){
            if (mResult[0].assessment.questionType=== "COMAUT") {
                let mCom = _.filter(
                    comunidades, function(o) {
                        return o.code === mResult[0].points;
                    }
                );

                if (mCom && mCom[0]) return  mCom[0].name;

                return "";

            }else if (mResult[0].assessment.questionType=== "MULTIPLE3" || mResult[0].assessment.questionType=== "MULTIPLE2" || mResult[0].assessment.questionType=== "MULTIPLE4") {
                let mText = mResult[0].subanswers.map(sub => sub.response.question).join(', ')

                return mText

            }else {
                if (mResult[0].response) {
                    return mResult[0]?.response?.question
                } else {
                    if (mResult[0].degree) {
                        return mResult[0]?.degree?.title
                    }
                }
            }
        }else{
            return "";
        }
    }

    const getResponseSubject = (code, pos) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]){
          if (pos === 0){
              return mResult[0]?.subject?.subject
          }
            let order = _.orderBy(mResult[0]?.subanswers, ["subject.order"],['asc']);

            if (pos === 1){
                return order[0]?.subject?.subject + ", " +  order[1]?.subject?.subject
            }
            if (pos === 2){
                return order[2]?.subject?.subject
            }
        }else{
            return "";
        }
    }

    useEffect(() => {

        let mTimeline =
        [
            {
                color: '#20388F',
                date:'20' + year + ' - 20' + (year+1),
                message: '<strong>' + t("tengo") + '</strong>: ' + getResponse(2) + '<br />'
                    + '<strong>' + t("tek.duranteeste3") + '</strong>: ' + getResponse(3) + '<br /><br />'
                    + '<strong>' + t("tek.satisfecho2") + '</strong>: ' + getResponse(4) + '<br /><br />'
            },
            {
                color: '#52C41A',
                date:'20' + (year+1) + ' - 20' + (year+2),
                message: '<strong>' + t("tek.encasocfgm") + '</strong>: ' + getResponse(5) + '<br />'

                    +  (getPoints(8) !== 999  ? ('<strong>' + t("tek.mcfgs") + '</strong>: ' + getResponse(8) + '<br /><br />') : '')
                    + (getResponseB(6)   ? ('<strong>' + t("tek.mbtx") + '</strong>: ' + getResponse(6) + '<br /><br />') : '')
            },
            {    color: '#F5222D',
                date:'20' + (year+2) + ' - 20' + (year+3),
                message:
                    (getPoints(8) !== 999  ? '<strong>' + t("tek.segundogs") + '</strong><br />' : '') +
                        (getResponseB(6)
                        ? '<strong>' + t("tek.segundob") + '</strong>' : '')
            },
            {
                color: '#20388F',
                date:'20' + (year+3) + ' - 20' + (year+4),
                message:
                    '<strong>' + t("tek.encasocfgs") + '</strong>: ' + getResponse(9) + '<br />'
                    + (getPoints(6) !== 999   ? '<strong>' + t("tek.encasobacn") + '</strong>: '  + getResponse(7) + '<br />': '')
                    + (getPoints(10) !== 999   ? '<strong>' + t("tek.miuni") + '</strong>: '  + getResponse(10) + '<br />': '')
                    + (getPoints(11) !== 999   ? '<strong>' + t("tek.estudiarenc") + '</strong>: '  + getResponse(11) + '<br />': '')
            }
        ];
        props.setTimeline(mTimeline)
        setTimelineData(mTimeline)
    },[year])

    return (
        <>
            {!props.forDownload &&
                <Timeline mode={'left'}>
                    {timelineData.map(item => <Timeline.Item
                            color={item.color}
                            key={item.date} label={item.date}>
                            <p dangerouslySetInnerHTML={{__html: item.message}}/>
                        </Timeline.Item>
                    )}
                </Timeline>
            }
        </>
    );
}

export default withTranslation()(TekFPM);
